<div class="p-list p-mt-5">
  <!-- Korigovati naslov i podnaslov -->

  <!-- Poslovanje -->
  <kodit-izvestaj-card
    class="p-col-12 p-md-6 p-lg-4"
    izvestajCardTitle="Poslovanje"
    izvestajCardSubtitle="Pregeled KPO knjige i njeno generisanje u PDF format"
    cardIcon="far fa-book"
    cardLink="poslovanje"
  ></kodit-izvestaj-card>

   <!-- Maloprodaja izvestaj -->
  <kodit-izvestaj-card
      *ngIf="shouldDisplayMaloprodaja"
      class="p-col-12 p-md-6 p-lg-4"
      izvestajCardTitle="MALOPRODAJA"
      izvestajCardSubtitle="Pregled izveštaja iz maloprodaje i generisanje u Excel i PDF format"
      cardIcon="fa-solid fa-cash-register"
      cardLink="maloprodaja-izvestaj"
  ></kodit-izvestaj-card>

     <!-- Veleprodaja izvestaj -->
  <kodit-izvestaj-card
    *ngIf="shouldDisplayVeleprodaja"
    class="p-col-12 p-md-6 p-lg-4"
      izvestajCardTitle="VELEPRODAJA"
      izvestajCardSubtitle="Pregled izveštaja iz veleprodaje i generisanje u Excel i PDF format"
      cardIcon="fa-solid fa-file"
      cardLink="veleprodaja-izvestaj"
  ></kodit-izvestaj-card>
</div>
